<b-modal v-model="modal_requirement_157" :size="dialogSize" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid dialog-body">
        <div class="w-100">
          <div class="box-margin-right work-support-message">
            {{ workSupportMessage }}
          </div>
        </div>
      </div>
    </b-overlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center">
      <b-button v-if="showButtonOn" size="sm" variant="primary" :disabled="isDisabledOn" @click="onExecuteClicked"
        class="mx-2 mt-2">
        {{ $t('individual.label_button_on') }}
      </b-button>
      <b-button v-if="showButtonOff" size="sm" variant="primary" :disabled="isDisabledOff" @click="onExecuteClicked"
        class="mx-2 mt-2">
        {{ $t('individual.label_button_off') }}
      </b-button>
      <b-button v-if="showButtonCancel" size="sm" variant="outline-primary" :disabled="isLoading"
        @click="onCancelClicked" class="mx-2 mt-2">
        {{ $t('message.common_button_cancel') }}
      </b-button>
      <b-button v-if="showButtonOk" size="sm" variant="primary" :disabled="isLoading" @click="onOkClicked"
        class="mx-2 mt-2">
        {{ $t('message.common_button_ok') }}
      </b-button>
    </div>
  </template>
</b-modal>